import { type } from "../types/types";

export const set_brands = (brands) => (dispatch) => {
  dispatch({
    type: type.SET_BRANDS,
    brands: brands,
  });
};
